import { useTranslation } from 'react-i18next';

import styles from './ConditionSection.module.scss';

export interface ConditionSectionProps {
  condition: string;
}

export const ConditionSection = ({ condition }: ConditionSectionProps) => {
  const { t } = useTranslation(['scenarioCommander']);
  return (
    <div className={styles.root} data-testid="condition-section">
      <div className={styles.titleLabel}>
        {t('scenarioCommander:whatHasHappened')}
      </div>
      <div className={styles.conditionLabel}>{condition}</div>
    </div>
  );
};
